import ServerLog, { TLogLevel } from '@client/models/serverLog.ts'

const serverLogModel = new ServerLog()

const toErrorJSON = (e: unknown) => (e instanceof Error ? { name: e.name, message: e.message, stack: e.stack } : e)

async function write(level: TLogLevel, message: string, metadata?: any) {
    serverLogModel
        .log({
            level,
            message,
            metadata,
        })
        .catch(() => {})
}

export const serverLog = {
    info: (message: string, metadata?: any) => write('info', message, metadata),
    debug: (message: string, metadata?: any) => write('debug', message, metadata),
    error: (message: string, err?: unknown, extra?: any) =>
        write('error', message, { ...extra, error: toErrorJSON(err) }),
}
